var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.chartData)?_c('apexchart',{staticClass:"apex-charts",attrs:{"height":"40","type":"area","dir":"ltr","series":_vm.series,"options":_vm.trendChartOptions}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }